export var selectFilename = function selectFilename(state) {
  return state.file.name;
};